import { CreditDebitNoteFigures } from "../../types/credit-debit-note-report.type";
import { formatNumber, numberWithCommas } from "../../utils";
import { NOTE_TYPE_LABEL } from "./constants";

/** How the reports name the notes and what they add up to. */
export const CREDIT_NOTE_LABEL = NOTE_TYPE_LABEL.CREDIT;
export const DEBIT_NOTE_LABEL = NOTE_TYPE_LABEL.DEBIT;
export const NET_LABEL = "สุทธิ";

/** `2 ใบ` — how many notes a figure is made of. */
export const noteCountLabel = (count: number): string => `${numberWithCommas(count)} ใบ`;

/** A baht amount with its minus before the symbol: `-฿1,000.00`. */
export const formatSignedBaht = (amount: number, decimals = 2): string =>
  `${amount < 0 ? "-" : ""}฿${formatNumber(Math.abs(amount), { decimals })}`;

/** Whether a period has a note amount to show; an absent amount (older backend) counts as none. */
export const hasNoteAmounts = (creditNoteAmount = 0, debitNoteAmount = 0): boolean =>
  creditNoteAmount !== 0 || debitNoteAmount !== 0;

/** Whether a day was made of any note at all, by count. */
export const hasNotes = (
  figures: Pick<CreditDebitNoteFigures, "credit_note_count" | "debit_note_count">,
): boolean => figures.credit_note_count > 0 || figures.debit_note_count > 0;
